
import { keyframes } from '../../../core/ds/index.js'

export const loadingKeyframes = keyframes({
  '0%': {
    transform: 'rotate(0)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
})

export const loadingCircleKeyframes = keyframes({
  '0%': {
    strokeDashoffset: 240,
  },
  '100%': {
    strokeDashoffset: 0,
  },
})
